<template>
	<div class="booking-component component-view fullscreen">
		<div class="container-fluid">
			<div class="row">
				<div class="col py-10">
          <LanguageSwitcher v-show="false"></LanguageSwitcher>

          <div class="text-center">
            <img src="/assets/images/hellers24.svg" class="logo"/>
          </div>

          <div id="tabs">
            <div class="tabs">
              <a v-on:click.prevent="activetab=1" v-bind:class="[ activetab === 1 ? 'active' : '' ]">{{ $t('booking.title') }}</a>
              <a v-on:click.prevent="activetab=4" v-bind:class="[ activetab === 4 ? 'active' : '' ]">{{ $t('booking.bookinscompletetitle') }}</a>
              <a v-on:click.prevent="activetab=2" v-bind:class="[ activetab === 2 ? 'active' : '' ]">{{ $t('booking.roomstitle') }}</a>
              <a v-on:click.prevent="activetab=3" v-bind:class="[ activetab === 3 ? 'active' : '' ]">{{ $t('booking.roomcategoriestitle') }}</a>
              <a @click="logout">Logout</a>
            </div>
            <div class="content">
              <div v-if="activetab === 1" class="tabcontent">
                  <BookingTable></BookingTable>
              </div>
              <div v-if="activetab === 2" class="tabcontent">
                  <RoomsTable></RoomsTable>
              </div>
              <div v-if="activetab === 3" class="tabcontent">
                  <RoomCategoriesTable></RoomCategoriesTable>
              </div>
              <div v-if="activetab === 4" class="tabcontent">
                  <BookingsCompleteTable></BookingsCompleteTable>
              </div>
            </div>
          </div>

				</div>
			</div>
		</div>
	</div>
</template>

<script>

	import axios from 'axios'
	import BookingTable from './../components/booking/bookingtable.vue'
	import RoomsTable from './../components/booking/roomstable.vue'
	import RoomCategoriesTable from './../components/booking/roomcategoriestable.vue'
  import BookingsCompleteTable from './../components/booking/bookingscompletetable.vue'
	import LanguageSwitcher from './../components/languageswitcher.vue'
  import { mapState } from 'vuex';

	export default {
		props: [],
		data: function () {
			return {
				allBookings: null,
				allRoomCategories: null,
        allRooms: null,
        activetab: 1
			}
    },
    computed: {
			...mapState('settings', ['config']),
		},
		mounted: function() {
			this.getAllBookings();
			this.getAllRoomCategories();
			this.getAllRooms();
		},
		components: {
			BookingTable,
      RoomsTable,
      RoomCategoriesTable,
      BookingsCompleteTable,
			LanguageSwitcher
		},
		methods: {
			saveAllBookings: function () {
				let formData = new FormData();
				let booking = null;

				for (booking in this.allBookings) {
					formData.append('allBookings[]', JSON.stringify(this.allBookings[booking]));
				}

				axios({
					method: 'post',
					url:  this.config.apiUrl + 'saveAllBookings',
          withCredentials: true,
					data: formData
				}).then(response => (this.getAllBookings()))
			},

			getAllBookings: function() {
				axios({
					method: 'get',
					url: this.config.apiUrl + 'getAllBookings',
          withCredentials: true
				})
					.then(response => (this.allBookings = response.data))
			},

      generateEmptyBookings: function() {
        var generateEmptyBookings = confirm("Sind Sie sicher dass Sie die restlichen Zimmer mit Spontanbuchungen ausfüllen wollen?");
				if (generateEmptyBookings) {
          axios({
            method: 'get',
            url: this.config.apiUrl + 'generateEmptyTerminalBookings',
            withCredentials: true
          }).then(response => (this.getAllBookings()));
        }
      },

      removeAllBookings: function() {
        let self = this;
        var question = confirm('Sollen alle Daten unwideruflich gelöscht werden (Daten können dannach nicht mehr wiederhergestellt werden!');
        if(question) {
          axios({
            method: 'get',
            url: this.config.apiUrl + 'removeAllBookings',
            withCredentials: true
          }).then(response => (
            self.getAllBookings()
          ))
        }
      },

			getAllRoomCategories: function() {
				axios({
					method: 'get',
					url: this.config.apiUrl + 'getAllRoomCategories',
          withCredentials: true
				})
					.then(response => (this.allRoomCategories = response.data))
			},

			getAllRooms: function() {
				axios({
					method: 'get',
					url: this.config.apiUrl + 'getAllRooms',
          withCredentials: true
				})
					.then(response => (this.allRooms = response.data))
			},
      logout: function() {
       	axios({
					method: 'get',
					url: this.config.apiUrl + 'logout',
          withCredentials: true
				}).then(response => (
          this.logoutFunc()
        ))
      },

      logoutFunc: function() {
        console.log("LOGOUT!!!");
        window.localStorage.setItem('authUser',null);
        var cookieData = 'PHPSESSID=;domain='+ window.location.host + ';expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        document.cookie = cookieData;
        var cookieData = 'PHPSESSID=;domain=backend.'+ window.location.host + ';expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        document.cookie = cookieData;

        var redirectUrl = window.location.protocol + "//" + window.location.host + "/#/login";
        window.document.location.href = redirectUrl;
      }
		}
	}
</script>

<style scoped lang="scss">
	.booking-component .saveAllBookings .btn-success {
		border-radius: 0;
	}

	.booking-component .saveAllBookings {
		text-align: center;
	}
</style>

<style lang="scss">
  .logo {
    max-width: 150px;
  }


	.vdp-datepicker .form-control {
		font-size: 1rem;
		padding: .375rem .75rem;
		-webkit-box-shadow: none;
		box-shadow: none;
		background: #fff;
		letter-spacing: 0;
	}

	.booking-component .form-control {
		border-radius: 0;
	}

	.booking-component input,
	.booking-component select.form-control {
		height: 34px;
		min-width: 64px;
	}


  /* Style the tabs */

  #tabs {

  }

  .tabs {
      overflow: hidden;
  }

  .tabs ul {
      list-style-type: none;
      margin-left: 20px;
  }

  .tabs a{
      background: linear-gradient(90deg,#989fa4,#c8d3d9,#989fa4);
      color: #000 !important;
      float: left;
      cursor: pointer;
      padding: 12px 24px;
      // transition: background-color 0.5s linear;

      -webkit-transition: background 1s ease-out;
      -moz-transition: background 1s ease-out;
      -o-transition: background 1s ease-out;
      transition: background 1s ease-out;

      border-right: none;
      font-weight: normal;
  }
  .tabs a:last-child {
      border-right: 1px solid #383639;
  }

  .tabs a:not(:last-child)  {
    margin-right: 0.75rem;
  }

  /* Change background color of tabs on hover */
  .tabs a:hover {
      background: linear-gradient(90deg,#72767a,#a6adb1,#7a8185);
  }

  /* Styling for active tab */
  .tabs a.active {
      background: linear-gradient(90deg,#b78417,#feef9f,#b78417);
      // font-weight: bold;
      cursor: default;

  }

  /* Style the tab content */
  .tabcontent {
      padding-top: .75rem;
  }
</style>
